import moment from 'moment';

type RequestAgeType = 'danger' | 'warning' | 'okay';

type RequestAgeResult = {
  formattedAge: string;
  type: RequestAgeType;
};

const MINUTE_IN_MS = 60 * 1000;
const HOUR_IN_MS = 60 * MINUTE_IN_MS;

export function calculateTimeThresholds({
  createdAt,
  dangerThresholdInHours,
  warningThresholdInHours,
}: {
  createdAt: string;
  dangerThresholdInHours: number;
  warningThresholdInHours: number;
}): RequestAgeResult {
  const now = moment();
  const created = moment(createdAt);
  const diffMs = now.diff(created);
  const diffHours = diffMs / HOUR_IN_MS;

  return {
    formattedAge: formatDuration(diffMs),
    type: determineType(
      diffHours,
      dangerThresholdInHours,
      warningThresholdInHours
    ),
  };
}

function formatDuration(diffMs: number): string {
  return moment.duration(diffMs).humanize();
}

function determineType(
  diffHours: number,
  dangerThresholdInHours: number,
  warningThresholdInHours: number
): RequestAgeType {
  if (diffHours > dangerThresholdInHours) {
    return 'danger';
  }

  if (diffHours > warningThresholdInHours) {
    return 'warning';
  }

  return 'okay';
}
